import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  uuid: '',
};

const scanSlice = createSlice({
  name: 'scan',
  initialState,
  reducers: {
    setUuid: (state, action: PayloadAction<string | undefined>) => {
      const newUuid = action.payload;
      return { ...state, uuid: newUuid ?? '' };
    },
  },
});

export const { setUuid } = scanSlice.actions;
export default scanSlice.reducer;
